import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { actions } from './settings.slice'
import { selectAllSettings } from './settings.selectors'

const { setUseCaching, setNoBusySpinner } = actions

export default function Settings() {
	const settings = useSelector(selectAllSettings)

	const dispatch = useDispatch()

    return (
        <div>
            <h2>Settings</h2>
            <div className='flex items-center gap-3 py-2'>
                <Switch id='useCaching' checked={settings.useCaching} onCheckedChange={() => dispatch(setUseCaching(!settings.useCaching))} />
                <Label htmlFor='useCaching'>useCaching</Label>
            </div>
            <div className='flex items-center gap-3 py-2'>
                <Switch id='noBusySpinner' checked={settings.noBusySpinner} onCheckedChange={() => dispatch(setNoBusySpinner(!settings.noBusySpinner))} />
                <Label htmlFor='noBusySpinner'>noBusySpinner</Label>
            </div>
        </div>
    )
}
